<script context="module">
  export const prerender = true;
</script>

<!-- <script async src="https://www.googletagmanager.com/gtag/js?id=AW-11002359683"></script> -->

<script lang="ts">
  import { onMount, onDestroy } from "svelte";
  import ObfuscateButton from "../buttons/ObfuscateButton.svelte";
  import DeobfuscateButton from "../buttons/DeobfuscateButton.svelte";
  import CopyButton from "../buttons/CopyButton.svelte";
  import ParaphraseButton from "../buttons/ParaphraseButton.svelte";
  import SynonymButton from "../buttons/SynonymButton.svelte";
  import ShareButton from "../buttons/ShareButton.svelte";
  import GoogleSignIn from "../GoogleSignIn.svelte";
  import TipsDemoSoon from "../components/TipsDemoSoon.svelte";
  import Instructions from "../components/Instructions.svelte";
  import Shop from "../components/Shop.svelte";
  import AdminOnly from "../components/AdminOnly.svelte";
  import PromoUrl from "../components/PromoUrl.svelte";
  import API from "../components/API.svelte";
  import Constellation from "../../scripts/constellation.min.js";
  import { isLoading, discount } from "../store";
  import { checkStillSubscribed } from "../firebaseOperations";

  let constellation;
  let canvasElement;

  // window.dataLayer = window.dataLayer || [];
  // function gtag(){dataLayer.push(arguments);}
  // gtag('js', new Date());

  // gtag('config', 'AW-11002359683');
  // Function to recreate the canvas and constellation
  function recreateConstellation() {
    // Remove the existing canvas if it exists
    if (canvasElement) {
      document.body.removeChild(canvasElement);
      canvasElement = null;
    }

    // Create and append a new canvas element to the body
    canvasElement = document.createElement("canvas");
    document.body.insertBefore(canvasElement, document.body.firstChild); // Ensures it's placed right after the body tag

    // Style the canvas
    canvasElement.style.position = "fixed";
    canvasElement.style.top = "0";
    canvasElement.style.left = "0";
    canvasElement.style.width = "100%";
    canvasElement.style.height = "100%";
    canvasElement.style.zIndex = "1"; // Ensure it's in the background
    canvasElement.style.pointerEvents = "none"; // Allow interaction with elements below
    // canvasElement.style.backgroundColor = 'rgba(128, 128, 128, 0.5)'; // Set canvas background to grey

    // Initialize the Constellation
    constellation = new Constellation({
      canvas: canvasElement,
      size: [window.innerWidth, window.innerHeight],
      starCount: 150,
      lineCount: 300,
      style: {
        starSize: 2,
        starColor: "#cccccc",
        lineColor: "#cccccc",
        lineSize: 1,
        starPadding: 2,
      },
      speed: {
        active: 0.2,
        passive: 0.1,
      },
      padding: [0, 0],
    });
  }
  // import FeedbackForm from "../components/FeedbackForm.svelte";
  import {
    userSignedIn,
    userData,
    paraphraseOptions,
    synonymOptions,
    selectedText,
    validatedPromoCode,
  } from "../store";
  import {
    fetchData,
    creditCallback,
    premiumCallback,
    apiCallback,
    transactionType,
    validateCode,
    verificationComplete,
  } from "../firebaseOperations";
  import Footer from "../components/Footer.svelte";

  let isTextSelected = false;

  let inputText: string = "";
  let aiResult: string = "AI Content: N/A%"; // New variable for AI result
  let charCountLeft: number = 0; // New variable for left character count
  let charCountRight: number = 0; // New variable for right character count
  let fontColorRight: string = "#666666"; // New variable for left counter font color

  let statusText = "";
  let statusColor = "black";
  let creditsText = "";

  let sessionId: any;
  let verificationUser: any;
  let urlPromoCode: any;
  let showPromoInterface = false;

  let successMessage = "";
  let errorMessage = "";

  let showSynonymOptions = false;
  let showParaphraseOptions = false;

  $: synonymOptions
    ? (showSynonymOptions = true)
    : (showSynonymOptions = false);

  let initials = "";
  $: if ($userData.name) {
    const names = $userData.name.split(" ");
    initials = `${names[0][0]}${names[1][0]}`;
  }

  let cloakLevel = 2;

  function signedOutOverlay() {
    document.getElementById("deobfuscate").classList.add("grey-overlay");
    document.getElementById("purchaseButton1").classList.add("grey-overlay");
    document.getElementById("purchaseButton2").classList.add("grey-overlay");
    document.getElementById("purchaseButton3").classList.add("grey-overlay");
    document.getElementById("purchasePremium").classList.add("grey-overlay");
    document
      .getElementById("purchasePremiumAnnual")
      .classList.add("grey-overlay");
  }
  function signedInOverlay() {
    document.getElementById("deobfuscate").classList.remove("grey-overlay");
    document.getElementById("purchaseButton1").classList.remove("grey-overlay");
    document.getElementById("purchaseButton2").classList.remove("grey-overlay");
    document.getElementById("purchaseButton3").classList.remove("grey-overlay");
    document.getElementById("purchasePremium").classList.remove("grey-overlay");
    document
      .getElementById("purchasePremiumAnnual")
      .classList.remove("grey-overlay");

    // document.getElementById("profilePicture").innerHTML = '<sl-avatar class="logo-image" on:click={toggleOverlay} initials=' + {initials} + ' label="User avatar"></sl-avatar>';
    $userSignedIn = true;
  }
  function handleTextSelection() {
    synonymOptions.set([]);
    paraphraseOptions.set([]);
    const textArea = document.getElementById("input-textarea");
    $selectedText = textArea.value.substring(
      textArea.selectionStart,
      textArea.selectionEnd,
    );
    isTextSelected =
      $selectedText.length > 0 && $selectedText != "" && $selectedText != " ";
    if (
      $selectedText.split(" ").length == 1 &&
      isTextSelected &&
      $userSignedIn
    ) {
      document.getElementById("synButton").classList.remove("grey-overlay");
      showSynonymOptions = true;
    } else {
      document.getElementById("synButton").classList.add("grey-overlay");
      showSynonymOptions = false;
    }

    if (
      $userSignedIn &&
      isTextSelected &&
      $selectedText.split(" ").length > 5 &&
      $selectedText.split(" ").length < 100
    ) {
      document.getElementById("paraButton").classList.remove("grey-overlay");
      showParaphraseOptions = true;
    } else {
      document.getElementById("paraButton").classList.add("grey-overlay");
      showParaphraseOptions = false;
    }
  }

  function replaceText(newText) {
    const textArea = document.getElementById("input-textarea");
    const startPos = textArea.selectionStart;
    const endPos = textArea.selectionEnd;
    if (
      !(newText == "No synonyms found!" || newText == "No paraphrases found!")
    ) {
      inputText =
        inputText.substring(0, startPos) +
        newText +
        inputText.substring(endPos);
    }
    $paraphraseOptions = []; // Clear options
    $synonymOptions = [];
    showParaphraseOptions = false; // Hide options
    showSynonymOptions = false;
  }

  async function handleObfuscate(event: CustomEvent<string>) {
    inputText = event.detail;
  }
  async function handleDeobfuscate(event: CustomEvent<string>) {
    inputText = event.detail;
  }
  async function handleCheckAI(event: CustomEvent<string>) {
    aiResult = event.detail;
  }
  async function handleParaphrase(event: CustomEvent<string>) {
    inputText = event.detail;
  }
  async function handleSynonym(event: CustomEvent<string>) {
    synonymOptions.set(event.detail);
  }

  function updateCharCounts() {
    const wordCount = inputText.split(/\s/).filter(Boolean).length;
    charCountLeft = wordCount;
    charCountRight = wordCount;
    fontColorRight =
      wordCount > 300 ? "red" : wordCount > 250 ? "yellow" : "#666666";
  }

  const urlParams = new URLSearchParams(window.location.search);
  verificationUser = urlParams.get("user");
  sessionId = urlParams.get("session_id");
  urlPromoCode = urlParams.get("code");
  // console.log(sessionId);

  // let urlParams: URLSearchParams;
  // try {
  //   urlParams = new URLSearchParams(window.location.search);
  //   sessionId = urlParams.get("session_id");
  // } catch (error) {
  //   console.log("URL search param error, redirecting to home page...");
  // }

  // when the window loads, we want to fetch the user's data
  window.onload = () => {
    cloakLevel = document.getElementById("cloakLevel").value; // required to initially check
  };
  let greeting = "";
  let timeOfDay = new Date().getHours();
  greeting = `Good ${timeOfDay < 12 ? "morning" : timeOfDay < 18 ? "afternoon" : "evening"}, friend!`;

  onMount(() => {
    const googleToken = localStorage.getItem("googleToken");
    if (googleToken) {
      fetchData(googleToken).then(async (data) => {
        $userData = data;
        if ($userData.premium) {
          let result = await checkStillSubscribed($userData.id);
          // console.log(result); should be 200 if still subscribed
        }
        if ($userData && $userData.admin) {
          statusText = "ADMIN MODE";
          statusColor = "red";
          creditsText = "Credits: \u221E";
          if ($userData.credits != null) {
            signedInOverlay();
          }
        }
        if ($userData && $userData.premium) {
          creditsText = "Credits: \u221E";
          document.getElementById("premiumTitle").hidden = false;
          signedInOverlay();
        } else if ($userData.credits != null) {
          creditsText = "Credits: " + $userData.credits;
          signedInOverlay();
        } else {
          creditsText = "";
          statusText = "";
          statusColor = "black";
        }

        if ($userData.name) {
          greeting = `Good ${timeOfDay < 12 ? "morning" : timeOfDay < 18 ? "afternoon" : "evening"}, ${$userData.name.split(" ")[0]}!`;
          document.getElementById("signIn").style.display = "none";
        }

        if ($userData.premium) {
          document.getElementById("creditpurchasesection").style.display =
            "none";
          document.getElementById("purchasepremiumbuttons").style.display =
            "none";
          document.getElementById("purchasetcmessage")?.innerHTML =
            "You already have TextCloaker Premium!";
        }
      });
    }

    const textArea = document.getElementById("input-textarea");
    textArea.addEventListener("input", () => {
      $selectedText = textArea.value.substring(
        textArea.selectionStart,
        textArea.selectionEnd,
      );
      isTextSelected =
        $selectedText.length > 0 && $selectedText != " " && $selectedText != "";
    });

    // recreateConstellation();
    // window.addEventListener('resize', recreateConstellation);
    
  });

  // onDestroy(() => {
  //   window.removeEventListener('resize', recreateConstellation);
  //   // Clean up by removing the canvas
  //   if (canvasElement) {
  //     document.body.removeChild(canvasElement);
  //   }
  // });

  async function transactionMade(sessionId) {
    let transaction_type = await transactionType(sessionId);

    if (transaction_type.transactionType == "api") {
      console.log("API transaction detected.");
      apiCallback(sessionId).then((result) => {
        if (result == 0) {
          successMessage =
            "API Purchase Successful! Please reload the page to see your updated interface.";
        } else {
          errorMessage = "API Purchase Failed!";
        }
      });
    }
    if (transaction_type.transactionType == "premium") {
      premiumCallback(sessionId).then((result) => {
        if (result == 0) {
          userData.update(($userData) => {
            creditsText = "Credits: \u221E"; // or fetch the new credits
            document.getElementById("premiumTitle").hidden = false;
            return $userData;
          });
          successMessage = "Purchase Successful!";

          const googleToken = localStorage.getItem("googleToken");
          setTimeout(() => {
            fetchData(googleToken).then((data) => {
              userData.set(data);
            });
          }, 2500);
        } else {
          errorMessage = "Purchase Failed!";
        }
      });
    } else if (transaction_type.transactionType == "credit") {
      let result = await creditCallback(sessionId);
      if (result == 0) {
        userData.update(($userData) => {
          creditsText = "Credits: " + $userData.credits; // or fetch the new credits
          return $userData;
        });
        successMessage = "Purchase Successful!";

        const googleToken = localStorage.getItem("googleToken");
        setTimeout(() => {
          fetchData(googleToken).then((data) => {
            userData.set(data);
          });
        }, 2500);
      } else {
        errorMessage = "Purchase Failed!";
      }
    }
    // window.location.reload(); // fucks up the tag analytics
  }
  $: if (sessionId) {
    transactionMade(sessionId);
  }

  $: if (verificationUser) {
    verificationComplete(verificationUser);
  }

  $: if (localStorage.getItem("validatedPromoCode")) {
    showPromoInterface = true;
    $validatedPromoCode = localStorage.getItem("validatedPromoCode");
    // if ($userSignedIn) {
    //             redeemCode($validatedPromoCode);
    //         } else {
    //             document.getElementById("promoCodeMessage").innerHTML = "Please sign in to redeem your promo code!";
    //         }
  }
  $: if (urlPromoCode) {
    validateCode(urlPromoCode).then((result) => {
      // console.log(result);
      if (result) {
        // result == true
        showPromoInterface = true;
        $validatedPromoCode = urlPromoCode;
      }
    });
  }
  
  window.history.replaceState({}, document.title, "/");
</script>

<div class="container">
  <div class="content">
    <div class="actualContent">
      <h3 class="title" id="greeting">{greeting}</h3>
      <div class="welcome">
        <!-- {#if !$userSignedIn}
        <div id="logged-out">
          <GoogleSignIn />
        </div>
      {/if} -->
        <p id="status" class="note" style="color: {statusColor};">
          {statusText}
        </p>
        <p
          id="credits"
          style="font-weight: bold; font-size: large;"
          class="note"
        >
          {creditsText}
        </p>
        <p class="subbertitle">
          Worried about being falsely accused for AI generated content? Cloak
          your text to make sure it'll be detected as 100% human generated!
        </p>
      </div>
      <div class="border-bottom" />

      <AdminOnly />
      {#if showPromoInterface}
        <PromoUrl />
      {/if}

      <div class="newSection">
        <div class="welcome">
          <Instructions />
        </div>

        <div class="input-container" style="padding-top:2rem;">
          <div class="input-obfuscate-container">
            <div class="textarea-container">
              <p class="note" id="diffText" style="text-decoration: none;">
                Your text should not look any different after you cloak/uncloak
                it. See "Helpful Tips" for more details.
              </p>
              <div class="copy-button-container">
                <CopyButton {inputText} />
              </div>
              <textarea
                class="input-textarea"
                id="input-textarea"
                bind:value={inputText}
                autofocus
                on:input={() => {
                  updateCharCounts();
                  handleTextSelection();
                }}
                on:mouseup={handleTextSelection}
                placeholder="Enter your text..."
              />
              <div class="share-button-container">
                <ShareButton />
              </div>
            </div>

            {#if $paraphraseOptions.length > 0}
              <div class="paraphrase-overlay">
                {#each $paraphraseOptions as option}
                  <button
                    class="paraphrase-option"
                    on:click={() => replaceText(option)}>{option}</button
                  >
                {/each}
              </div>
            {/if}

            {#if $synonymOptions.length > 0}
              <div class="paraphrase-overlay">
                {#each $synonymOptions as option}
                  <button
                    class="paraphrase-option"
                    on:click={() => replaceText(option)}>{option}</button
                  >
                {/each}
              </div>
            {/if}
            <div class="main-button-container" style="margin-top:3rem;">
              <ObfuscateButton
                {cloakLevel}
                {inputText}
                on:success={handleObfuscate}
              />
            </div>
          </div>
        </div>
        <!-- <div class="inputSubtext">
        <div class="counters">
          <p class="counter-left" id="airesult">{aiResult}</p>
          <p class="counter-right" style="color: {fontColorRight};">
            AI Content Detector: {charCountRight} / 300
          </p>
        </div>
      </div> -->

        <div class="allButtons">
          <!--         
        <div class="halfButtons" style="margin-top:6rem;">
         
        </div> -->
          <div class="halfButtons">
            <h4 style="padding-top:1rem;">Additional Options</h4>
            <div class="button-container">
              <DeobfuscateButton {inputText} on:success={handleDeobfuscate} />
              <ParaphraseButton on:success={handleParaphrase} />
              <SynonymButton on:success={handleSynonym} />
            </div>
          </div>
        </div>
      </div>
      <div class="newSection">
        <Shop />
      </div>
      <!-- <div class="newSection">
        <API />
      </div> -->

      <p class="purchase-success">{successMessage}</p>
      <p class="purchase-error">{errorMessage}</p>
      <div class="welcome">
        <div class="border-bottom" />

        <div class="newSection">
          <TipsDemoSoon />
        </div>
        <Footer />
      </div>
      <br />
    </div>
  </div>
</div>
